import React from 'react';
import ChartCard from '../components/dashboard/ChartCard';
import { userActivityData, featureUsageData, revenueData, aiAssistantData } from '../utils/mockData';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip, BarChart, Bar, CartesianGrid, XAxis, YAxis } from 'recharts';
const Analytics: React.FC = () => {
  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
  return <div className="space-y-6" data-id="element-672">
      <div data-id="element-673">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-674">
          Platform Analytics
        </h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-675">
          Detailed analytics and KPIs for the Fintrove platform.
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-676">
        <ChartCard title="User Activity" subtitle="Daily active and new users" data={userActivityData} type="bar" dataKeys={['active', 'new']} colors={['#3B82F6', '#10B981']} data-id="element-677" />
        <ChartCard title="Revenue Breakdown" subtitle="Monthly revenue by source" data={revenueData} type="line" dataKeys={['premium', 'referrals']} colors={['#8B5CF6', '#EC4899']} data-id="element-678" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-679">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-680">
          <div className="mb-4" data-id="element-681">
            <h3 className="text-lg font-medium text-gray-900 dark:text-white" data-id="element-682">
              Feature Usage
            </h3>
            <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-683">
              Percentage of users using each feature
            </p>
          </div>
          <div className="h-[300px]" data-id="element-684">
            <ResponsiveContainer width="100%" height="100%" data-id="element-685">
              <BarChart data={featureUsageData} margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0
            }} data-id="element-686">
                <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" data-id="element-687" />
                <XAxis dataKey="name" stroke="#9CA3AF" data-id="element-688" />
                <YAxis stroke="#9CA3AF" data-id="element-689" />
                <Tooltip contentStyle={{
                backgroundColor: 'white',
                border: '1px solid #e5e7eb',
                borderRadius: '0.375rem'
              }} data-id="element-690" />
                <Legend data-id="element-691" />
                <Bar dataKey="usage" fill="#3B82F6" radius={[4, 4, 0, 0]} data-id="element-692" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-693">
          <div className="mb-4" data-id="element-694">
            <h3 className="text-lg font-medium text-gray-900 dark:text-white" data-id="element-695">
              AI Assistant Usage
            </h3>
            <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-696">
              Distribution of AI persona usage
            </p>
          </div>
          <div className="h-[300px]" data-id="element-697">
            <ResponsiveContainer width="100%" height="100%" data-id="element-698">
              <PieChart data-id="element-699">
                <Pie data={aiAssistantData} cx="50%" cy="50%" labelLine={false} outerRadius={100} fill="#8884d8" dataKey="usage" label={({
                name,
                percent
              }) => `${name}: ${(percent * 100).toFixed(0)}%`} data-id="element-700">
                  {aiAssistantData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-701" />)}
                </Pie>
                <Tooltip data-id="element-702" />
                <Legend data-id="element-703" />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
      <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6" data-id="element-704">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-705">
          Conversion Funnels
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-706">
          <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg" data-id="element-707">
            <h4 className="text-base font-medium text-gray-900 dark:text-white mb-2" data-id="element-708">
              Onboarding
            </h4>
            <div className="space-y-2" data-id="element-709">
              <div data-id="element-710">
                <div className="flex justify-between text-sm mb-1" data-id="element-711">
                  <span className="text-gray-500 dark:text-gray-400" data-id="element-712">
                    Sign Up
                  </span>
                  <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-713">
                    100%
                  </span>
                </div>
                <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2" data-id="element-714">
                  <div className="bg-blue-600 h-2 rounded-full" style={{
                  width: '100%'
                }} data-id="element-715"></div>
                </div>
              </div>
              <div data-id="element-716">
                <div className="flex justify-between text-sm mb-1" data-id="element-717">
                  <span className="text-gray-500 dark:text-gray-400" data-id="element-718">
                    Profile Completion
                  </span>
                  <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-719">
                    82%
                  </span>
                </div>
                <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2" data-id="element-720">
                  <div className="bg-blue-600 h-2 rounded-full" style={{
                  width: '82%'
                }} data-id="element-721"></div>
                </div>
              </div>
              <div data-id="element-722">
                <div className="flex justify-between text-sm mb-1" data-id="element-723">
                  <span className="text-gray-500 dark:text-gray-400" data-id="element-724">
                    Bank Connection
                  </span>
                  <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-725">
                    65%
                  </span>
                </div>
                <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2" data-id="element-726">
                  <div className="bg-blue-600 h-2 rounded-full" style={{
                  width: '65%'
                }} data-id="element-727"></div>
                </div>
              </div>
              <div data-id="element-728">
                <div className="flex justify-between text-sm mb-1" data-id="element-729">
                  <span className="text-gray-500 dark:text-gray-400" data-id="element-730">
                    Goal Setting
                  </span>
                  <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-731">
                    48%
                  </span>
                </div>
                <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2" data-id="element-732">
                  <div className="bg-blue-600 h-2 rounded-full" style={{
                  width: '48%'
                }} data-id="element-733"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg" data-id="element-734">
            <h4 className="text-base font-medium text-gray-900 dark:text-white mb-2" data-id="element-735">
              Premium Conversion
            </h4>
            <div className="space-y-2" data-id="element-736">
              <div data-id="element-737">
                <div className="flex justify-between text-sm mb-1" data-id="element-738">
                  <span className="text-gray-500 dark:text-gray-400" data-id="element-739">
                    Free Users
                  </span>
                  <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-740">
                    100%
                  </span>
                </div>
                <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2" data-id="element-741">
                  <div className="bg-purple-600 h-2 rounded-full" style={{
                  width: '100%'
                }} data-id="element-742"></div>
                </div>
              </div>
              <div data-id="element-743">
                <div className="flex justify-between text-sm mb-1" data-id="element-744">
                  <span className="text-gray-500 dark:text-gray-400" data-id="element-745">
                    Feature Exploration
                  </span>
                  <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-746">
                    72%
                  </span>
                </div>
                <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2" data-id="element-747">
                  <div className="bg-purple-600 h-2 rounded-full" style={{
                  width: '72%'
                }} data-id="element-748"></div>
                </div>
              </div>
              <div data-id="element-749">
                <div className="flex justify-between text-sm mb-1" data-id="element-750">
                  <span className="text-gray-500 dark:text-gray-400" data-id="element-751">
                    Premium Page Visit
                  </span>
                  <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-752">
                    34%
                  </span>
                </div>
                <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2" data-id="element-753">
                  <div className="bg-purple-600 h-2 rounded-full" style={{
                  width: '34%'
                }} data-id="element-754"></div>
                </div>
              </div>
              <div data-id="element-755">
                <div className="flex justify-between text-sm mb-1" data-id="element-756">
                  <span className="text-gray-500 dark:text-gray-400" data-id="element-757">
                    Premium Subscription
                  </span>
                  <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-758">
                    18%
                  </span>
                </div>
                <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2" data-id="element-759">
                  <div className="bg-purple-600 h-2 rounded-full" style={{
                  width: '18%'
                }} data-id="element-760"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg" data-id="element-761">
            <h4 className="text-base font-medium text-gray-900 dark:text-white mb-2" data-id="element-762">
              Investment Referrals
            </h4>
            <div className="space-y-2" data-id="element-763">
              <div data-id="element-764">
                <div className="flex justify-between text-sm mb-1" data-id="element-765">
                  <span className="text-gray-500 dark:text-gray-400" data-id="element-766">
                    Investment Page Visit
                  </span>
                  <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-767">
                    100%
                  </span>
                </div>
                <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2" data-id="element-768">
                  <div className="bg-green-600 h-2 rounded-full" style={{
                  width: '100%'
                }} data-id="element-769"></div>
                </div>
              </div>
              <div data-id="element-770">
                <div className="flex justify-between text-sm mb-1" data-id="element-771">
                  <span className="text-gray-500 dark:text-gray-400" data-id="element-772">
                    Option Exploration
                  </span>
                  <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-773">
                    85%
                  </span>
                </div>
                <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2" data-id="element-774">
                  <div className="bg-green-600 h-2 rounded-full" style={{
                  width: '85%'
                }} data-id="element-775"></div>
                </div>
              </div>
              <div data-id="element-776">
                <div className="flex justify-between text-sm mb-1" data-id="element-777">
                  <span className="text-gray-500 dark:text-gray-400" data-id="element-778">
                    Partner Click
                  </span>
                  <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-779">
                    42%
                  </span>
                </div>
                <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2" data-id="element-780">
                  <div className="bg-green-600 h-2 rounded-full" style={{
                  width: '42%'
                }} data-id="element-781"></div>
                </div>
              </div>
              <div data-id="element-782">
                <div className="flex justify-between text-sm mb-1" data-id="element-783">
                  <span className="text-gray-500 dark:text-gray-400" data-id="element-784">
                    Conversion
                  </span>
                  <span className="font-medium text-gray-700 dark:text-gray-200" data-id="element-785">
                    12%
                  </span>
                </div>
                <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2" data-id="element-786">
                  <div className="bg-green-600 h-2 rounded-full" style={{
                  width: '12%'
                }} data-id="element-787"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Analytics;